import type { FC } from 'react';
import type { Theme } from '@material-ui/core';
import { experimentalStyled } from '@material-ui/core/styles';
import type { SxProps } from '@material-ui/system';
import { ReactComponent as Imagen } from '../assets/img/logoNavBar.svg';

interface LogoProps {
  sx?: SxProps<Theme>;
}

const LogoRoot = experimentalStyled('svg')();

const LogoNavBar: FC<LogoProps> = (props) => (
  <LogoRoot
    height="52"
    version="1.1"
    viewBox="80 0 42 42"
    width="52"
    {...props}
  >
    <title>Release</title>
    <Imagen />
  </LogoRoot>
);

export default LogoNavBar;
